import React, { useEffect, useState } from "react";
import PanelLayout from "layouts/PanelLayout";
import boy from "assets/layout_img/boy.svg";
import { jwtDecode } from "jwt-decode";
import { FiEdit3, FiEye, FiEyeOff } from "react-icons/fi";
import "styles/student.css";

const Profile = () => {
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    username: "",
    bio: "",
  });

  const [modalOpen, setModalOpen] = useState(false);

  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      try {
        const decoded = jwtDecode(token);

        setUser({
          firstName:
            decoded[
              "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"
            ] || "",
          lastName:
            decoded[
              "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname"
            ] || "",
          username:
            decoded[
              "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
            ] || "",
          bio: decoded["bio"] || "Bio yo‘q",
        });
      } catch (err) {
        console.log("Token decode error", err);
      }
    }
  }, []);

  const changePassword = () => {
    if (newPass !== confirmPass) {
      alert("Yangi parollar mos emas!");
      return;
    }
    alert("Parol muvaffaqiyatli o'zgartirildi!");
    setModalOpen(false);
    setOldPass("");
    setNewPass("");
    setConfirmPass("");
  };

  return (
    <PanelLayout>
      <div className="profile-container">
        <div className="profile-card">
          <img src={boy} className="profile-avatar" />

          <div className="profile-info">
            <div className="info-row">
              <span>Ism</span>
              <p>{user.firstName}</p>
            </div>

            <div className="info-row">
              <span>Familiya</span>
              <p>{user.lastName}</p>
            </div>

            <div className="info-row">
              <span>Username</span>
              <p>{user.username}</p>
            </div>

            <div className="info-row">
              <span>Bio</span>
              <p>{user.bio}</p>
            </div>

            <div className="info-row">
              <span>Parol</span>
              <div className="password-edit">
                <p>********</p>
                <FiEdit3
                  className="edit-icon"
                  onClick={() => setModalOpen(true)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {modalOpen && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Parolni almashtirish</h3>

            <label>Eski parol</label>
            <div className="pass-input">
              <input
                type={showOld ? "text" : "password"}
                value={oldPass}
                onChange={(e) => setOldPass(e.target.value)}
              />
              <span onClick={() => setShowOld(!showOld)}>
                {showOld ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>

            <label>Yangi parol</label>
            <div className="pass-input">
              <input
                type={showNew ? "text" : "password"}
                value={newPass}
                onChange={(e) => setNewPass(e.target.value)}
              />
              <span onClick={() => setShowNew(!showNew)}>
                {showNew ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>

            <label>Yangi parolni tasdiqlang</label>
            <div className="pass-input">
              <input
                type={showConfirm ? "text" : "password"}
                value={confirmPass}
                onChange={(e) => setConfirmPass(e.target.value)}
              />
              <span onClick={() => setShowConfirm(!showConfirm)}>
                {showConfirm ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>

            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setModalOpen(false)}
              >
                Bekor qilish
              </button>
              <button className="save-btn" onClick={changePassword}>
                Almashtirish
              </button>
            </div>
          </div>
        </div>
      )}
    </PanelLayout>
  );
};

export default Profile;
